(() => {
  angular
    .module('app')
    .controller(
      'host.tenantCreateEditIrbmMyInvoisSettings',
      TenantCreateEditIrbmMyInvoisSettingsController
    );

  TenantCreateEditIrbmMyInvoisSettingsController.$inject = ['$stateParams'];

  function TenantCreateEditIrbmMyInvoisSettingsController($stateParams) {
    const vm = this;
    vm.loading = 0;
    vm.saving = 0;

    vm.id = $stateParams.id;
    vm.entityType = $stateParams.entityType === 'panels' ? 'clinics' : $stateParams.entityType;
    vm.tenancyName = $stateParams.tenancyName;
    vm.countryCode = 'MY';

    vm.editIrbmMyInvoisSettingsWidget = null;
    vm.save = save;

    init();

    function init() {}

    function save() {
      if (vm.countryCode === 'MY' && vm.editIrbmMyInvoisSettingsWidget != null) {
        vm.editIrbmMyInvoisSettingsWidget.validateForm();
      }
    }
  }
})();
